const $ = window.$;
const swal = window.swal;

import {
  reset_buttons,
  toast_errors,
} from 'form_helpers';

"use strict";

export function update_fields() {
  var form = $( '.edit_resource' ),
      fields;

  update_positions( form );

  fields = form.serializeJSON();

  if ( !$.isEmptyObject( fields ) ) {
    delete fields.resource.batches_attributes;
    delete fields.resource.name;
    delete fields.resource.url;

    $.ajax( {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
      },
      method: 'patch',
      url: location.pathname.split( 'edit' )[ 0 ]  + 'value_update',
      data: fields,
      success: function( d ){
        $( '[data-bs-toggle="tooltip"]' ).tooltip( 'dispose' );
        window.Turbo.renderStreamMessage( d );
      }
    } );
  }
}

export function update_positions( element ) {
  $( element ).find( 'input[name^="resource[fields_attributes]"][name$="[position]"]' ).each( function( index ) {
    $( this ).val( index + 1 );
  } );
}

var AdminResources = {
  init: function() {
    var hook = false,
        values_updated = false;

    $( 'body' ).on( 'change', '.resource-values input', function(){
      values_updated = true;
    } );

    $( '#resources-modal' ).on( 'hidden.bs.modal', function(){
      reset_buttons( '.create-resource-btn' );
      $( '#resource_name, #resource_url, #field_name' ).val( '' );
      $( '.resource-fields .table tbody' ).empty();
      auto_hide();
    } );

    $( '#resources-modal' ).on( 'shown.bs.modal', function(){
      $( '#resource_name' ).trigger( 'focus' );
    } );

    if( !$( 'form' ).hasClass( 'edit_resource' ) ) {
      $( '#resource_name' ).on( 'paste mouseup keyup blur', function(){
        $( '#resource_url' ).val( this.value.toLowerCase().replace( /[^a-z0-9]/g, '_' ) );
      } );
    }

    $( '#fld_add' ).on( 'click', function(){
      var $fn = $( '#field_name' ),
          count = $( '#fld_list' ).find( 'tbody' ).length,
          $tab = $( '#fld_list' ),
          new_id = ( new Date ).getTime(),
          row = $( '#field_row' ).text().
                                  replace( /\{i}/g, '' ).
                                  replace( /\{name}/g, $fn.val().toLowerCase() ).
                                  replace( /\{position}/g, count + 1 ).
                                  replace( /\{row_id}/g, new_id );

      if( $fn.val() == '' ) {
        toast_errors( 'You must supply a field name' );
        $fn.trigger( 'focus' );
        return false;
      }

      if( values_updated == true ){
        toast_errors( 'Save the values before adding <strong>' + $fn.val() + '</strong> field' );
        return false;
      }

      $tab.append( row );

      $( '[data-bs-toggle="tooltip"]' ).tooltip();

      $fn.val( '' ).trigger( 'focus' );
      auto_hide();

      // Update fields
      update_fields();
      return false;
    } );

    $( 'body' ).on( 'click', '.fld_rem', function(){
      var $this = $( this ),
          field_name = $this.parents( 'tr:first' ).find( 'input' ).val();

      if( values_updated == true ){
        toast_errors( 'Save the values before removing <strong>' + field_name + '</strong> field' );
        return false;
      }

      swal.fire( {
        title: 'Are you sure you want to delete the <strong>' + field_name + '</strong> field?\n This action will automatically remove all values.',
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d9534f",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: () => {
          $this.tooltip( 'dispose' );
          $this.parents( 'tr:first' ).remove();
          auto_hide();
          update_fields();
        }
      } );

      return false;
    } );

    $( 'body' ).on( 'click', '#batch_add', function(){
      var $tab = $( '#val_tbl' ),
          new_id = ( new Date ).getTime(),
          row = $( '#value_row' ).text().
                                  replace( /\{i}/g, '' ).
                                  replace( /\{row_id}/g, new_id );
      $tab.append( row );
      $tab.find( 'tr.hidden:last' ).remove();
      $tab.find( 'tr:visible:last input:visible:first' ).trigger( 'focus' );
      $( '[data-bs-toggle="tooltip"]' ).tooltip();
      return false;
    } );

    $( 'body' )
      .on( 'click', '.val_rem', function(){
        $( this ).tooltip( 'dispose' );
        $( this ).parents( 'tr:first' ).remove();
        if( !hook ) {
          hook = true;
        }
        values_updated = true;
        return false;
      } )
      .on( 'click', '.batch_en', function(){
        var $row = $( this ).parents( 'tr:first' );
        if( this.checked ){
          $row.removeClass( 'table-danger' );
        } else {
          $row.addClass( 'table-danger' );
        }
      } );

    if( $( 'form' ).hasClass( 'edit_resource' ) ) {
      $( '.edit_resource' ).on( 'change', ':input', function() {
        if( !hook ) {
          hook = true;
        }
      } );
    }

    $( 'body' ).on( 'click', '.resources-save-btn', function() {
      hook = false;
    } );

    function enableHook() {
      window.onbeforeunload = function(){
        if( hook ){
          return 'Changes that you made may not be saved.';
        }
      };
    }
    enableHook();

    function auto_hide() {
      if( $( '.resource-fields tbody tr:not(.hidden)' ).length ) {
        $( '.resource-fields' ).show();
      } else {
        $( '.resource-fields' ).hide();
      }
    }
    auto_hide();
  }
};
$( function(){
  AdminResources.init();

  let target = [ 'resource_fields', 'resource_values' ],
      observer = new MutationObserver( () => { $( '[data-bs-toggle="tooltip"]' ).tooltip(); } );

  target.forEach( function( el ){
    let $el = $( '#' + el )[ 0 ];
    if( $el ) {
      observer.observe( $el, { childList: true, subtree: false } );
    }
  } );
} );
